module.exports = __webpack_public_path__ + "img/6.27465a0e.jpg";